export enum PropertyType { String, Number, Boolean, Date, SimpleArray, ObjectArray, Dictionary, Object, PredefinedArray, PredefinedArrayMulti, Color, NumberSlider, StringCopyValue, BooleanToggle, LabelText, Cron, Json, MessageBar }
